import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { TagSequenceMVP } from 'iframe/ts/player/controller/sequence/TagSequenceMVP';
import { TagSequenceScripted } from 'iframe/ts/player/controller/sequence/TagSequenceScripted';
export class IFrameTagEmbedManager extends IFramePlayerAbstractClass {
    #embedSequence;
    constructor(iframePlayer) {
        super(iframePlayer, 'IFrameTagEmbedManager');
        switch (this.scripted) {
            case false:
                this.#embedSequence = new TagSequenceMVP(this.iframePlayer);
                break;
            case true:
                this.#embedSequence = new TagSequenceScripted(this.iframePlayer);
                break;
        }
    }
}
